/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconMedicalPack: {
  name: 'medical_pack';
  data: string;
} = {
  name: 'medical_pack',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M220.99 222.599a4.77 4.77 0 0 0-4.781 4.781v23.906a4.77 4.77 0 0 0 4.781 4.781h28.688a4.77 4.77 0 0 0 4.781-4.781V227.38a4.77 4.77 0 0 0-4.781-4.781H220.99zm0 4.781h28.688v23.906H220.99V227.38zm11.953 4.781v4.781h-4.781v4.781h4.781v4.781h4.781v-4.781h4.781v-4.781h-4.781v-4.781h-4.781z" transform="matrix(15 0 0 15 -3224 -3284)"/></svg>`,
};
